import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

class Input extends PureComponent {
  handleChange = evt => {
    if (this.props.onChange) {
      let value = evt.target.value;
      if (this.props.type === 'checkbox') value = evt.target.checked;
      this.props.onChange(this.props.name, value);
    }
  };

  render() {
    const {tag, value, ...inputProps} = this.props;
    const Tag = tag || 'input';

    return (
      <Tag
        type="text"
        className="form-control"
        autoComplete={this.props.autoComplete || this.props.name}
        {...inputProps}
        value={value || ''}
        onChange={this.handleChange} />
    )
  }
}

Input.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default Input



// WEBPACK FOOTER //
// ./src/components/Input.js